<template>
    <b-dropdown size="sm" class="float-right" :variant="variant" right :title="showToolTip ? tooltip : ''">
      <template slot="button-content">
        <i class="fa fa-file"></i>
      </template>
      <b-dropdown-item-button
        v-for="item in items" 
        :key="item.id" 
        @click="addFile(item.id)"    
        :style="item.textColor ? `border: 2px solid ${item.textColor};` : ''"
      >
        {{ item.text }}
      </b-dropdown-item-button>
      <input ref="uploader" class="d-none" type="file" accept="image/*;capture=camera" @change="onFileChanged"/>
    </b-dropdown>    
</template>
<!--
  
-->

<script>

export default ({
  name: "button-add-file-by-group",

  props: {    
    variant: {
      type: String,
      default: 'warning'
    },
    tooltip: {
      type: String,
      default: 'Добавить файл'
    },
    items: {
      type: Array,
      default: null
    },
    text: {
      type: String,
      default: null
    },
  },

  data: function() {
    return {
      isSelecting: false,
      currentId: null
    }
  },

  computed: {
    showToolTip() {
      return this.$store.state.userSettings.showTooltips;
    }
  },
  
  methods: {
    addFile(id) {
      this.currentId = id
      this.isSelecting = true;

      // After obtaining the focus when closing the FilePicker, return the button state to normal
      window.addEventListener('focus', () => {
          this.isSelecting = false
      }, { once: true });
      
      this.$refs.uploader.value = null
      // Trigger click on the FileInput
      this.$refs.uploader.click();
    },

    onFileChanged(e) {
      this.$emit('onAddFile', {id: this.currentId, file: e.target.files[0]})
    }
  }
})
</script>
